.bottomContainer {
  bottom: 0.75em;
  display: flex;
  position: absolute;
  flex-direction: row;
  right: 1em;
  padding: 0.5em;
  min-width: 10em;
}
.bottomContent {
  text-align: center;
  flex-grow: 1;
}
